import { useList } from 'admin';
import { Load } from 'api';

export const useAllDealLoads = (dealId: number) => {
  return useList<Load>({
    dataProviderName: 'inspections',
    filters: [
      {
        field: 'deal_id',
        operator: 'eq',
        value: dealId,
      },
    ],
    pagination: {
      pageSize: 10000, // fetch all loads
    },
    resource: '/v1/loads/',
  });
};
